import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import quotes, { SOURCE_HANDLES } from './QuoteStore';

// Editorial pull-quote: a big oxblood quotation mark over a Fraunces-italic
// line, with a typewriter attribution rule. Colors come from theme tokens, so
// it adapts to light/dark. A random quote is chosen per mount.
class QuoteBubble extends Component {
	constructor(props) {
		super(props);
		const q = this.randomQuote();
		this.state = {
			quote: q.quote,
			quoteLines: q.quoteLines,
			author: q.author,
			source: q.source,
		};
	}

	randomQuote() {
		return quotes[Math.floor(Math.random() * quotes.length)];
	}

	attribution() {
		const { author, source } = this.state;
		if (author && source) return author + ' · ' + source;
		return author || source || 'Unknown';
	}

	// The Shopify handle whose catalog lightbox this quote's book opens, or
	// undefined for quotes from sources that aren't Newfangle catalog titles.
	bookHandle() {
		return this.state.source && SOURCE_HANDLES[this.state.source];
	}

	render() {
		const { quote, quoteLines } = this.state;
		const handle = this.bookHandle();
		const attr = this.attribution();
		return (
			<figure className="nf-quote">
				<span className="nf-quote-mark" aria-hidden="true">&ldquo;</span>
				<blockquote className="nf-quote-text">
					{quoteLines && quoteLines.length
						? quoteLines.map((line, i) => (
								<React.Fragment key={i}>
									{line}
									{i < quoteLines.length - 1 && <br />}
								</React.Fragment>
						  ))
						: quote}
				</blockquote>
				<figcaption className="nf-quote-attr">
					{handle ? (
						<Link to={'/catalog?book=' + encodeURIComponent(handle)} title={'View ' + this.state.source + ' in the catalog'}>
							{attr}
						</Link>
					) : (
						attr
					)}
				</figcaption>
			</figure>
		);
	}
}

export default QuoteBubble;
